import { useContext } from 'react';
import { ConsentContext, type ConsentContextValue } from './consentContext';

export function useConsent(): ConsentContextValue {
    const context = useContext(ConsentContext);
    if (!context) throw new Error('useConsent must be used inside ConsentProvider');
    return context;
}
